import CitySEOHead from "@/components/feature/CitySEOHead";
import MelbourneHeroSection from "./components/HeroSection";
import MelbourneStickyNav from "./components/StickyNav";
import MelbourneProcessingTimeSection from "./components/ProcessingTimeSection";
import MelbourneServicesSection from "./components/ServicesSection";
import MelbourneLocalAreaSection from "./components/LocalAreaSection";
import MelbourneTestimonialsSection from "./components/TestimonialsSection";
import MelbourneAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MelbourneComparisonSection from "./components/ComparisonSection";
import MelbourneMistakesSection from "./components/MistakesSection";
import MelbourneHowItWorksSection from "./components/HowItWorksSection";
import MelbourneFAQSection, { faqs } from "./components/FAQSection";
import MelbourneHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MelbourneFinalCTA from "./components/FinalCTA";
import MelbourneTravelTimingSection from "./components/TravelTimingSection";
import MelbourneDestinationsSection from "./components/DestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Melbourne, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Melbourne, FL — as fast as 2–3 business days. A+ BBB rated, registered State Dept. courier serving Melbourne, Palm Bay, Cocoa Beach, and Space Coast travelers needing urgent, fast, or same-day passport help.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function MelbournePage() {
  return (
    <>
      <CitySEOHead
        city="Melbourne"
        state="Florida"
        stateAbbr="FL"
        route="/melbourne"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Melbourne, Florida"
        geoPosition="28.0836;-80.6081"
        keywords="expedited passport Melbourne, emergency passport Melbourne FL, same day passport Melbourne, fast passport Florida, passport renewal Melbourne, Melbourne passport courier, Space Coast passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-16"
      />

      <div className="font-sans">
        <MelbourneHeroSection />
        <MelbourneStickyNav />
        <MelbourneProcessingTimeSection />
        <MelbourneServicesSection />
        <MelbourneLocalAreaSection />
        <MelbourneTravelTimingSection />
        <MelbourneDestinationsSection />
        <MelbourneTestimonialsSection />
        <MelbourneAcceptanceFacilitiesSection />
        <MelbourneComparisonSection />
        <MelbourneMistakesSection />
        <MelbourneHowItWorksSection />
        <MelbourneFAQSection />
        <MelbourneHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/melbourne" state="FL" />
        <MelbourneFinalCTA />
      </div>
    </>
  );
}